/**
 * @desc 导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.systemForecast.exportBySkuAndSite.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/systemForecast/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
